/**
 * Events API
 */

import { apiClient } from './client'

// 重新导出 types
export type {
  EventSummary,
  EventDetail,
  TweetInfo,
  MentionedAccount,
  EngagementStats,
  NarrativeInfo,
  DatesResponse,
  NarrativesResponse,
  EventsResponse,
  PolymarketMatch,
  PolymarketResponse,
  InterpretResponse,
  RoleInterpretation,
} from '../types/event'

// 导入类型
import type {
  EventDetail,
  DatesResponse,
  NarrativesResponse,
  EventsResponse,
  PolymarketResponse,
} from '../types/event'

// API 函数
export const eventsApi = {
  getDates: () =>
    apiClient.get<DatesResponse>('/api/dates'),

  getEvents: (params: {
    date?: string
    narrative?: string
    token?: string
    page?: number
    limit?: number
    lang?: string
  }) =>
    apiClient.get<EventsResponse>('/api/events', params),

  getEvent: (eventId: string, date?: string, lang?: string) =>
    apiClient.get<EventDetail>(`/api/events/${eventId}`, { ...(date && { date }), ...(lang && { lang }) }),

  getNarratives: (date?: string, lang?: string) =>
    apiClient.get<NarrativesResponse>('/api/narratives', { ...(date && { date }), ...(lang && { lang }) }),

  getPolymarket: (eventId: string) =>
    apiClient.get<PolymarketResponse>(`/api/events/${eventId}/polymarket`),
}
